import PortalIdParser from 'PortalIdParser';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import ContentViewport from './ContentViewport';
import ContentControlWrapper from './ContentControlWrapper';
import { replacePlaceholderWithPortalId } from '../utils/RoutingUtils';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'link-content';
const SkipLink = styled(UIButton).withConfig({
  displayName: "LinkContent__SkipLink",
  componentId: "sc-1brjxof-0"
})(["font-weight:500 !important;"]);
const LinkContent = ({
  contentType,
  ctaCopy,
  description,
  name,
  href,
  onFinish = () => {},
  onSkip = () => {},
  hasClicked,
  onRead = () => {}
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(ContentViewport, {
    wrapperClassName: BASE_CLASS_NAME,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      className: `${BASE_CLASS_NAME}__container`,
      direction: "column",
      justify: "start",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx("h1", {
        className: "m-bottom-4",
        children: name
      }), /*#__PURE__*/_jsx("p", {
        className: "m-bottom-8",
        children: description
      }), !hasClicked ? /*#__PURE__*/_jsx(UIButton, {
        className: `m-bottom-12 ${BASE_CLASS_NAME}__progress-button`,
        external: true,
        href: replacePlaceholderWithPortalId(PortalIdParser.getPortalIdFromPath(), href),
        onClick: onRead,
        use: "primary",
        children: ctaCopy || /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `learningCenter.linkContent.buttonAltText`,
          options: {
            name: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.resources.type.${contentType}`
            })
          }
        })
      }) : /*#__PURE__*/_jsx(UIButton, {
        className: `m-bottom-12 ${BASE_CLASS_NAME}__progress-button`,
        onClick: onFinish,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.common.next`
        })
      }), /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.linkContent.newTabText"
        })
      })]
    })
  }), /*#__PURE__*/_jsx(ContentControlWrapper, {
    className: `${BASE_CLASS_NAME}__content-control`,
    children: /*#__PURE__*/_jsx(SkipLink, {
      onClick: onSkip,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.linkContent.skip"
      })
    })
  })]
});
export default LinkContent;